import React, { useState } from 'react';
import { archiveroService } from '../services/archiveroService';
import { Info, FileText, Upload, CheckCircle, Paperclip, Plus, Trash2 } from 'lucide-react';
import toast from 'react-hot-toast';

export default function ArchiveroPublico() {
  const [tipoTramite, setTipoTramite] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [resMensaje, setResMensaje] = useState('');
  const [numeroSeguimiento, setNumeroSeguimiento] = useState('');

  const [fileInputs, setFileInputs] = useState([{ id: Date.now(), file: null }]);

  const [formData, setFormData] = useState({
    rut_solicitante: '',
    nombre_solicitante: '',
    email: '',
    telefono: '',
    notaria: '',
    fecha: '',
    repertorio: '',
    con_vigencia: false,
    anio: '',
    numero_protocolizacion: '',
    archivos_adjuntos: []
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleFileChange = (id, file) => {
    setFileInputs(prev => prev.map(input => input.id === id ? { ...input, file } : input));
  };

  const handleAddInput = (e) => {
    e.preventDefault();
    setFileInputs(prev => [...prev, { id: Date.now(), file: null }]);
  };

  const handleRemoveInput = (e, id) => {
    e.preventDefault();
    setFileInputs(prev => prev.filter(input => input.id !== id));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    setLoading(true);

    const payload = new FormData();
    Object.keys(formData).forEach(key => {
      if (key === 'archivos_adjuntos') return;
      if (formData[key] !== null && formData[key] !== '') {
        if (typeof formData[key] === 'boolean') {
          payload.append(key, formData[key] ? '1' : '0');
        } else {
          payload.append(key, formData[key]);
        }
      }
    });

    fileInputs.forEach(input => {
      if (input.file) {
        payload.append('archivos_adjuntos[]', input.file);
      }
    });

    try {
      let res;
      if (tipoTramite === 'escritura') {
        res = await archiveroService.createEscritura(payload);
      } else if (tipoTramite === 'protocolizado') {
        res = await archiveroService.createProtocolizado(payload);
      }
      
      setSuccess(true);
      setResMensaje(res?.data?.message || 'Solicitud enviada exitosamente');
      setNumeroSeguimiento(res?.data?.numero_seguimiento || 'ARCH-SUCCESS');
      toast.success('Solicitud enviada exitosamente');
    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || 'Error al enviar solicitud');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="container" style={{ padding: '4rem 1rem' }}>
        <div className="glass-card animate-scale-in" style={{ textAlign: 'center', maxWidth: 600, margin: '0 auto' }}>
          <CheckCircle size={64} style={{ color: 'var(--success)', marginBottom: '1.5rem', margin: '0 auto' }} />
          <h2 style={{ marginBottom: '1rem' }}>¡Solicitud Recibida!</h2>
          <p className="text-muted" style={{ fontSize: '1.15rem', marginBottom: '1.5rem' }}>
            {resMensaje || 'Verifica tu bandeja de entrada'}
          </p>
          <div style={{ background: 'var(--info-bg)', padding: '1.5rem', borderRadius: '12px', marginBottom: '2rem', textAlign: 'left', border: '1px solid var(--info)' }}>
            <p style={{ margin: 0, fontWeight: 500, color: 'var(--primary-dark)' }}>
              Se ha enviado un enlace de validación a <strong>{formData.email}</strong>.
              Es obligatorio confirmarlo para procesar la solicitud.
            </p>
          </div>
          <button className="btn btn-primary btn-lg" onClick={() => window.location.reload()}>
            Nueva Solicitud
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="container" style={{ padding: '2rem clamp(16px,4vw,48px) 4rem', maxWidth: '800px', margin: '0 auto' }}>
      
      <div className="animate-fade-in" style={{ marginBottom: '2.5rem' }}>
        <h1 className="section-title">
          <FileText size={28} color="var(--primary)" style={{ display: 'inline', verticalAlign: 'text-bottom', marginRight: '8px' }} />
          Archivero Judicial
        </h1>
        <span className="accent-line" />
        <p className="section-subtitle">Portal para la solicitud de copias de escrituras y documentos protocolizados.</p>
      </div>

      <div className="glass-card animate-scale-in" style={{ textAlign: 'left', background: 'var(--bg-surface)' }}>

        <div className="form-group">
          <label>Seleccione el tipo de trámite</label>
          <select className="form-control" value={tipoTramite} onChange={(e) => setTipoTramite(e.target.value)}>
            <option value="">-- Seleccione una opción --</option>
            <option value="escritura">Copia de Escritura Pública</option>
            <option value="protocolizado">Documentos Protocolizados</option>
            <option value="desarchivo">Desarchivo de Causa</option>
            <option value="expediente">Copia de Expediente</option>
          </select>
        </div>

        {/* INFORMATIVE VIEWS */}
        {(tipoTramite === 'desarchivo' || tipoTramite === 'expediente') && (
          <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: 8, padding: '1.5rem', marginTop: '1rem' }}>
            <h4 style={{ color: '#1e3a8a', display: 'flex', alignItems: 'center', gap: '0.5rem', marginTop: 0 }}>
              <Info size={20} />
              Trámite Presencial
            </h4>
            {tipoTramite === 'desarchivo' ? (
              <p style={{ color: '#1e40af', marginBottom: 0, lineHeight: 1.6 }}>
                Para solicitar un Desarchivo de Causa, debe dirigirse primero al tribunal respectivo para solicitar el desarchivo. <br /><br />
                Para pagar en el archivero, necesitará el comprobante del tribunal e indicar <strong>Rol de la causa</strong>, <strong>Año</strong> y <strong>Legajo de archivo</strong>. El archivero operará solo tras recibir un oficio del tribunal.
              </p>
            ) : (
              <p style={{ color: '#1e40af', marginBottom: 0, lineHeight: 1.6 }}>
                Para solicitar una Copia de Expediente, debe ir al tribunal correspondiente, completar el formulario, y luego, con el documento timbrado, solicitar la copia respectiva de manera presencial en el Archivero.
              </p>
            )}
          </div>
        )}

        {/* TRANSACTIONAL FORMS */}
        {(tipoTramite === 'escritura' || tipoTramite === 'protocolizado') && (
          <form onSubmit={handleSubmit} style={{ marginTop: '2rem' }}>
            <h3 style={{ marginBottom: '1rem', color: 'var(--primary-dark)', borderBottom: '1px solid #e2e8f0', paddingBottom: '0.5rem' }}>
              Datos del Solicitante
            </h3>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
              <div className="form-group">
                <label>RUT Solicitante</label>
                <input type="text" name="rut_solicitante" className="form-control" value={formData.rut_solicitante} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label>Nombre Completo</label>
                <input type="text" name="nombre_solicitante" className="form-control" value={formData.nombre_solicitante} onChange={handleChange} required />
              </div>
              <div className="form-group-row">
                <div className="form-group">
                  <label>Correo Electrónico</label>
                  <input type="email" name="email" className="form-control" value={formData.email} onChange={handleChange} required />
                </div>
                <div className="form-group">
                  <label>Teléfono de Contacto</label>
                  <input type="text" name="telefono" className="form-control" value={formData.telefono} onChange={handleChange} required />
                </div>
              </div>
            </div>

            <h3 style={{ marginBottom: '1rem', color: 'var(--primary-dark)', borderBottom: '1px solid #e2e8f0', paddingBottom: '0.5rem' }}>
              Detalle del Documento
            </h3>
            
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
              <div className="form-group">
                <label>Notaría</label>
                <select name="notaria" className="form-control" value={formData.notaria} onChange={handleChange} required>
                  <option value="">Seleccione notaría...</option>
                  <option value="primera_san_carlos">Primera Notaría de San Carlos</option>
                  <option value="segunda_san_carlos">Segunda Notaría de San Carlos</option>
                </select>
                <small className="text-muted">Si es de otra jurisdicción, el trámite no podrá procesarse.</small>
              </div>

              {tipoTramite === 'escritura' && (
                <>
                  <div className="form-group">
                    <label>Año</label>
                    <input type="number" name="anio" className="form-control" placeholder="Ej: 2023" min="1900" max="2100" value={formData.anio} onChange={handleChange} required />
                  </div>
                  <div className="form-group">
                    <label>Repertorio</label>
                    <input type="number" name="repertorio" className="form-control" value={formData.repertorio} onChange={handleChange} required />
                  </div>
                  <div className="form-group" style={{ marginTop: '1.5rem', gridColumn: '1 / -1' }}>
                    <label style={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: '12px', 
                      padding: '1rem', 
                      background: formData.con_vigencia ? 'rgba(5, 150, 105, 0.05)' : '#f8fafc',
                      border: `1px solid ${formData.con_vigencia ? '#059669' : '#e2e8f0'}`,
                      borderRadius: '8px',
                      cursor: 'pointer',
                      transition: 'all 0.2s',
                      margin: 0
                    }}>
                      <input 
                        type="checkbox" 
                        name="con_vigencia" 
                        checked={formData.con_vigencia} 
                        onChange={handleChange}
                        style={{ width: '20px', height: '20px', cursor: 'pointer', margin: 0 }}
                      />
                      <div>
                        <div style={{ fontWeight: 700, color: formData.con_vigencia ? '#059669' : 'inherit' }}>
                          Copia con Vigencia
                        </div>
                        <div style={{ fontSize: '0.8rem', color: 'var(--text-muted)', marginTop: '2px', fontWeight: 'normal' }}>
                          Conlleva una firma adicional y costo extra.
                        </div>
                      </div>
                    </label>
                  </div>
                </>
              )}

              {tipoTramite === 'protocolizado' && (
                <>
                  <div className="form-group">
                    <label>Año</label>
                    <input type="number" name="anio" className="form-control" placeholder="Ej: 2023" min="1900" max="2100" value={formData.anio} onChange={handleChange} required />
                  </div>
                  <div className="form-group">
                    <label>Número de Protocolización</label>
                    <input type="number" name="numero_protocolizacion" className="form-control" value={formData.numero_protocolizacion} onChange={handleChange} required />
                  </div>
                  <div className="form-group">
                    <label>Repertorio (Opcional)</label>
                    <input type="number" name="repertorio" className="form-control" value={formData.repertorio} onChange={handleChange} />
                  </div>
                </>
              )}
            </div>

            <div className="form-group" style={{ marginTop: '1.5rem' }}>
              <label style={{ display: 'block', fontSize: '0.9rem', fontWeight: 600, color: 'var(--text-main)', marginBottom: '0.5rem' }}>
                Adjuntar Documentos de Referencia (Opcional)
              </label>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6rem' }}>
                {fileInputs.map((input) => (
                  <div key={input.id} style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <div style={{ 
                      flex: 1, 
                      border: '1px solid var(--border-color)', 
                      borderRadius: 6, 
                      padding: '0.4rem 0.6rem',
                      display: 'flex',
                      alignItems: 'center',
                      background: 'var(--bg-surface)'
                    }}>
                      <Paperclip size={14} style={{ marginRight: 8, color: 'var(--copper)' }} />
                      <input 
                        type="file" 
                        accept=".pdf,.jpg,.jpeg,.png"
                        onChange={(e) => handleFileChange(input.id, e.target.files[0])}
                        style={{ flex: 1, fontSize: '0.85rem' }} 
                      />
                    </div>
                    {fileInputs.length > 1 && (
                      <button 
                        type="button"
                        className="btn btn-sm" 
                        style={{ background: '#fee2e2', color: '#ef4444', border: '1px solid #fca5a5', padding: '0.4rem 0.6rem' }}
                        onClick={(e) => handleRemoveInput(e, input.id)}
                        title="Eliminar archivo"
                      >
                        <Trash2 size={16} />
                      </button>
                    )}
                  </div>
                ))}
              </div>

              <button 
                type="button"
                className="btn btn-sm" 
                style={{ marginTop: '0.8rem', display: 'flex', alignItems: 'center', gap: 6, background: '#f1f5f9', color: '#475569', border: '1px solid #cbd5e1' }}
                onClick={handleAddInput}
              >
                <Plus size={14} /> Agregar otro archivo
              </button>
              <small className="text-muted" style={{ display: 'block', marginTop: '1rem' }}>Si no conoce todos los datos técnicos, suba una foto o escáner del documento para facilitar la búsqueda. Formatos: .pdf, .jpg, .png</small>
            </div>

            <button type="submit" className="btn btn-primary btn-lg" style={{ width: '100%', padding: '1.2rem', marginTop: '2rem' }} disabled={loading}>
              {loading ? <><span className="spinner" /> Procesando...</> : 'Enviar Solicitud'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
